import React from 'react'

import { connect } from 'react-redux'
import { Container, Card } from 'react-bootstrap'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import CompetitionService from 'src/services/CompetitionService'
import { userCan } from 'src/store/user/userActions'
import { route } from 'src/utils/routes'
import { IProduct } from 'src/services/types/product'
import { IState } from 'src/store'

import Error401 from 'src/pages/Error/401.page'
import Header from 'src/components/Layout/Header/Header'
import NotFound from 'src/components/Error/NotFound'
import CompetitionForm from 'src/components/Competition/CompetitionForm'

const competitionService = new CompetitionService()

interface IProps extends RouteComponentProps {
  match: any
  history: any
  user: any
  userCan: (permission: string) => boolean
}

const CompetitionUpdate: React.FC<IProps> = ({
  match,
  history,
  user,
  userCan,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [product, setProduct] = React.useState<IProduct>()

  React.useEffect(() => {
    if (userCan('update_competition')) {
      competitionService
        .fetchById(match.params.id)
        .then((product) => setProduct(product))
        .finally(() => setIsLoading(false))
    }
  }, [userCan, match.params.id])

  if (!userCan('update_competition')) return <Error401 />

  return (
    <>
      <Header
        title={
          isLoading
            ? 'Competition'
            : product
            ? `${product.name}`
            : 'Competition product not found'
        }
        backText="Competition Products"
        onBack={() => history.push(route('competition'))}
      />
      <div className="page-container">
        <Container>
          <Card>
            <Card.Header>
              <Card.Title>Competition Product Details</Card.Title>
            </Card.Header>
            <Card.Body className="pt-0">
              {!isLoading && product ? (
                <CompetitionForm
                  user={user}
                  type="update"
                  product={product}
                  updateProduct={(updatedValues) => {
                    setProduct({ ...product, ...updatedValues })
                  }}
                />
              ) : null}

              {!isLoading && !product ? (
                <div className="my-5">
                  <NotFound summary="Product not found" />
                </div>
              ) : null}

              {isLoading && (
                <div className="d-flex justify-content-center py-5">
                  <figure className="spinner primary" />
                </div>
              )}
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  )
}

export default connect((state: IState) => ({ user: state.user }), { userCan })(
  withRouter(CompetitionUpdate)
)
